import { render, staticRenderFns } from "./carControl.vue?vue&type=template&id=2fb64e4c&scoped=true"
import script from "./carControl.vue?vue&type=script&lang=js"
export * from "./carControl.vue?vue&type=script&lang=js"
import style0 from "./carControl.vue?vue&type=style&index=0&id=2fb64e4c&prod&lang=css&scoped=true"
import style1 from "./carControl.vue?vue&type=style&index=1&id=2fb64e4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb64e4c",
  null
  
)

export default component.exports